import React from "react";
import {Button, Row} from "antd";
import { CancelWhiteSVG, PrintColorWhiteSVG, SaveWhiteIconSVG } from "assets";
import { PauseOutlined } from "@ant-design/icons";
import Icon from "../../../../../../../assets/icons";
import "./ListBotton.scss"
const Save = (handleFunc, disable?: boolean, icon?: boolean): JSX.Element => {
    return (
        <Button
            className="ListBotton"
            type="primary"
            htmlType="submit"
            disabled={disable}
            onClick={handleFunc}
            icon={<SaveWhiteIconSVG />}
        >
            Lưu lại
        </Button>
    );
};
const Cancel = (handleFunc, disable?: boolean): JSX.Element => {
    return (
        <Button
            className="ListBotton"
            type="primary"
            htmlType="submit"
            disabled={disable}
            danger
            onClick={handleFunc}
            icon={<CancelWhiteSVG />}
           // style={{ backgroundColor: "red", borderColor: "red" }}

        >
            Hủy bỏ
        </Button>
    );
};
const edit = (handleFunc, disable?: boolean): JSX.Element => {
    return (
        <Button
            className="btn-sub"
            type="ghost"
            htmlType="submit"
            disabled={disable}
            danger
            onClick={handleFunc}
            icon={<Icon.edit />}
            // style={{ display: disable ? "block" : "none" }}

        >
            Chỉnh sửa
        </Button>
    );
};



export {
    Save,
    Cancel,
    edit,

};
